module.exports = __webpack_public_path__ + "img/Super_Star_32.01825434.png";